export const name = '@lifi/sdk';
export const version = '2.5.2';
